import React from 'react';

import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

interface IRegisterLayout {
  children: any;
}

export const RegisterLayout = ({ children }: IRegisterLayout) => {
  return (
    <Box
      component={'div'}
      display={'flex'}
      flexDirection={'column'}
      justifyContent={'center'}
      alignItems={'start'}
      bgcolor={'background.default'}
      borderRadius={'16px'}
      height={'100%'}
      padding={'12px 12px 24px 12px'}
    >
      <BoxContainerRegister>{children}</BoxContainerRegister>
    </Box>
  );
};
const BoxContainerRegister = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  padding: '15px 15x 15px 15px',
  borderRadius: '16px',
  margiBottom: '1em',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
}));
